export type IconStatus = 'DONE' | 'ERROR' | 'PAUSE' | 'INFO';

export type StatusConfig = {
  iconClass: string;
  backgroundClass: string;
}

export const statusConfig: { [key in IconStatus]: StatusConfig } = {
  DONE: { iconClass: 'check-status-icon', backgroundClass: 'green' },
  ERROR: { iconClass: 'error-status-icon', backgroundClass: 'red' },
  PAUSE: { iconClass: 'pause-status-icon', backgroundClass: 'orange' },
  INFO: { iconClass: 'info-status-icon', backgroundClass: 'blue' }
};
